import { render, staticRenderFns } from "./coach-view-page.vue?vue&type=template&id=6720c7ab&"
import script from "./coach-view-page.vue?vue&type=script&lang=js&"
export * from "./coach-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports